import React from 'react';
import clsx from 'clsx';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { useTranslation } from 'react-i18next';

import Icon from '../../../icons/Icon';
import { ICONS } from '../../../icons';

import scss from './BrandSocials.module.scss';

const mockedData = {
  score: 76,
  trend: 69,
  prevScore: 83,
};

function SocialCardValueCell({ data = mockedData, header }) {
  const { t } = useTranslation();
  const { score, trend, prevScore } = data;
  const trendFactor = trendEvaluator(trend, score);

  const tooltipTitle = `${t('previous')}: ${String(prevScore)}`;

  return (
    <div className={scss.cellValue}>
      <span className={scss.cellHeader}>{header}</span>

      <div className={scss.cellContent}>
        <span className={scss.cellValueTitle}>{score}</span>

        <StyledTooltip title={tooltipTitle} placement='top' disableInteractive arrow>
          <span
            className={clsx(
              scss.cellValueOffset,
              trendFactor === 1 && scss.cellValueOffset_increase,
              trendFactor === -1 && scss.cellValueOffset_decrease,
            )}>
            {trend}
            <Icon icon={ICONS.ArrowUp} disableCommonStyles />
          </span>
        </StyledTooltip>
      </div>
    </div>
  );
}

export default SocialCardValueCell;

function trendEvaluator(trend) {
  return trend < 0 ? -1 : 1;
}

const StyledTooltip = styled(({ className, ...props }) => <Tooltip {...props} classes={{ popper: className }} />)({
  [`& .${tooltipClasses.tooltip}`]: {
    background: 'var(--table-row-bg-hover)',
    color: 'var(--text-stressed)',
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    fontFamily: 'Inter',
    fontSize: '12px',
    padding: '8px',
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: 'var(--table-row-bg-hover)',
  },
  [`& .${tooltipClasses.tooltipPlacementTop}`]: {
    bottom: '10px',
    left: '-8px',
  },
});
